import deviceMenu from '@js/common/deviceMenu.js';
import { statisticComponent } from '@js/modules/statistic-component.js';

deviceMenu();
statisticComponent();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {

    // =========================
    // 🔥 Anchor click + menu close + redirect
    // =========================
    document.addEventListener('click', function(e) {

        const link = e.target.closest('a:not(.skip-link)');
        if (!link) {return;}

        const href = link.getAttribute('href');
        if (!href) {return;}

        if (href.startsWith('#')) {

            e.preventDefault();
            e.stopPropagation();

            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);

            // 🔥 CLOSE MOBILE MENU
            document.body.classList.remove('menu-open', 'nav-open', 'open');

            document.querySelectorAll('.active').forEach(el => {
                el.classList.remove('active');
            });

            const hamburger = document.querySelector('.hamburger');
            if (hamburger) {
                hamburger.classList.remove('is-clicked');
            }

            if (targetElement) {
                // ✅ same page scroll
                setTimeout(() => {
                    const targetPosition =
                        targetElement.getBoundingClientRect().top +
                        window.pageYOffset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });

                    // ✅ FIX
                    window.history.pushState(null, '', `#${targetId}`);
                }, 300);

            } else {
                // ✅ redirect to homepage
                setTimeout(() => {
                    window.location.href = `./#${targetId}`;
                }, 200);
            }
        }

    });


    // =========================
    // 🔥 Page load par hash scroll
    // =========================
    const hash = window.location.hash;

    if (hash) {
        const targetId = hash.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            setTimeout(() => {
                const targetPosition =
                    targetElement.getBoundingClientRect().top +
                    window.pageYOffset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth',
                });
            }, 300);
        }
    }

});


/* Use jQuery code Start
------------------------------------------------------------------------------*/
(function($) {

    function setIgTitleHeight() {
        const $titles = $('.icon-grid-section .ig-title');

        if (!$titles.length) {return;}

        $titles.css('min-height', '');

        const rows = {};

        $titles.each(function() {
            const top = $(this).position().top;

            if (!rows[top]) {rows[top] = [];}

            rows[top].push($(this));
        });

        $.each(rows, function(key, row) {
            let maxHeight = 0;

            row.forEach(function($el) {
                const h = $el.outerHeight();
                if (h > maxHeight) {maxHeight = h;}
            });

            row.forEach(function($el) {
                $el.css('min-height', maxHeight + 'px');
            });
        });
    }

    // ✅ FIXED (outside function)
    function setPsTitleHeight() {
        const titles = document.querySelectorAll('.ps-title');

        if (!titles.length) {return;}

        let maxHeight = 0;

        titles.forEach(el => el.style.height = 'auto');

        titles.forEach(el => {
            if (el.offsetHeight > maxHeight) {
                maxHeight = el.offsetHeight;
            }
        });

        titles.forEach(el => {
            el.style.height = maxHeight + 'px';
        });
    }

    $(window).on('load resize', function() {
        setIgTitleHeight();
        setPsTitleHeight();
    });

})(jQuery);
/* ------------------------------------------------------------------------------ */



document.querySelectorAll('.mbnav a').forEach(link => {
    link.addEventListener('click', () => {

        const hamburgers = document.querySelectorAll('.hamburger');
        const mbnav = document.querySelector('.mbnav');

        // 🔥 close hamburger icon
        hamburgers.forEach(btn => btn.classList.remove('is-clicked'));

        // 🔥 CLOSE MENU (REAL CLASS)
        mbnav?.classList.remove('is-open');

        // 🔥 body cleanup (optional)
        document.body.classList.remove('menu-open', 'nav-open', 'open');
    });
});